export default function ESmartCardDownload() {
    return(
        <></>
    )
}